<template>
  <header>
    <div class="bg-header-desktop bg-header-mobile"></div>
  </header>
</template>

<style lang="scss" scoped>
/* Medium devices (tablets, 768px and up) */
header {
  height: 86px;
  background-color: hsl(180, 29%, 50%);
}

@media (max-width: 575px) {
  .bg-header-mobile {
    background-image: url("../../assets/images/bg-header-mobile.svg");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
  }
  header {
    height: 150px;
  }
}

@media (min-width: 576px) {
  .bg-header-desktop {
    background-image: url("../../assets/images/bg-header-desktop.svg");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
  }
}
</style>

